import { useEffect } from 'react';
import GoogleTagManagerNg from './GoogleTagManagerNg';
import { EcommerceTrackingEvent } from './types';

export default function useTrackEcommerce(
  trackingEvent: EcommerceTrackingEvent | null,
  trackingIdentifier: string | null,
): void {
  useEffect(() => {
    if (
      trackingEvent == null ||
      trackingEvent.items == null ||
      trackingEvent.items.length === 0 ||
      trackingIdentifier == null
    ) {
      return;
    }
    const { event, ...properties } = trackingEvent;
    GoogleTagManagerNg.event(event, properties);
  }, [trackingIdentifier]);
}
